module.exports = __webpack_public_path__ + "b4f5ba55.svg";